import { useParams, Link } from "react-router-dom";
import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { allComics, categoryNames } from "@/mocks/comics-detail";

const ITEMS_PER_PAGE = 8;

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [page, setPage] = useState(1);

  const categoryName = categoryNames[slug || ""] || "分类";
  const comics = allComics.filter((c) => c.categorySlug === slug);
  const totalPages = Math.ceil(comics.length / ITEMS_PER_PAGE);
  const paginatedComics = comics.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <nav aria-label="面包屑导航" className="px-6 md:px-10 py-4">
          <ol className="flex items-center gap-2 text-sm text-foreground-500">
            <li><Link to="/" className="hover:text-foreground-900 transition-colors">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-xs"></i></li>
            <li><span className="text-foreground-900 font-medium">{categoryName}</span></li>
          </ol>
        </nav>

        <section className="px-6 md:px-10 py-6 md:py-10 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
              {categoryName}漫画
            </h1>
            <p className="text-sm text-foreground-500 mb-6">共 {comics.length} 部作品</p>

            <div className="flex flex-wrap gap-2 mb-8">
              {Object.entries(categoryNames).map(([key, name]) => (
                <Link
                  key={key}
                  to={`/category/${key}`}
                  className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer ${
                    key === slug
                      ? "bg-foreground-950 text-white"
                      : "bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200"
                  }`}
                >
                  {name}
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {paginatedComics.map((comic) => (
                <Link key={comic.id} to={`/comic/${comic.id}`} className="group block">
                  <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-200">
                    <img
                      src={comic.coverImage}
                      alt={comic.title}
                      title={`${comic.title} - 韩漫屋${categoryName}漫画`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-2 left-2 bg-accent-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                      {comic.rating}
                    </div>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{comic.title}</h3>
                  <p className="text-xs text-foreground-400 mt-0.5">{comic.author}</p>
                  <p className="text-xs text-foreground-500 mt-0.5">{comic.latestChapter}</p>
                </Link>
              ))}
            </div>

            {totalPages > 1 && (
              <div className="flex items-center justify-center gap-2 mt-10">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                  <button
                    key={p}
                    onClick={() => setPage(p)}
                    className={`w-9 h-9 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                      p === page
                        ? "bg-foreground-950 text-white"
                        : "text-foreground-600 hover:bg-background-100"
                    }`}
                  >
                    {p}
                  </button>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}